import {AppearanceTypes} from 'react-toast-notifications';

export const notificationsReducerKey = 'notifications';

export const levels = {
   INFO: 'info',
   WARN: 'warning',
   ERROR: 'error',
   SUCCESS: 'success',
} as const;

export type IToast = {
   id: string;
   time: Date;
   message: string;
   level: AppearanceTypes;
};

export const PUSH_TOAST = `${notificationsReducerKey}/PUSH_TOAST`;
export const CLOSE_TOAST = `${notificationsReducerKey}/CLOSE_TOAST`;
export const REMOVE_TOAST = `${notificationsReducerKey}/REMOVE_TOAST`;
export const REMOVE_ALL_TOASTS = `${notificationsReducerKey}/REMOVE_ALL_TOASTS`;
